import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { GlobalSchema } from "@/components/GlobalSchema";
import Landing from "@/pages/Landing";
import ServiziPage from "@/pages/ServiziPage";
import AziendaPage from "@/pages/AziendaPage";
import RealizzazioniPage from "@/pages/RealizzazioniPage";
import ContattiPage from "@/pages/ContattiPage";
import FaqPage from "@/pages/FaqPage";
import Configuratore from "@/pages/Configuratore";
import TracciaOrdine from "@/pages/TracciaOrdine";
import AdminOrdini from "@/pages/AdminOrdini";
import BlogIndex from "@/pages/BlogIndex";
import BlogArticle from "@/pages/BlogArticle";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import MeravigliaDelVetro from "@/pages/MeravigliaDelVetro";
import LavoraConNoi from "@/pages/LavoraConNoi";
import { CookieBanner } from "@/components/CookieBanner";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
  return (
    <div className="App">
      <GlobalSchema />
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/vetrate-panoramiche-vepa" element={<ServiziPage />} />
            <Route path="/azienda-vetrate-panoramiche-vepa" element={<AziendaPage />} />
            <Route path="/realizzazioni-vetrate-panoramiche" element={<RealizzazioniPage />} />
            <Route path="/contatti-vetrate-panoramiche" element={<ContattiPage />} />
            <Route path="/faq-vetrate-panoramiche-vepa" element={<FaqPage />} />
            <Route path="/configuratore" element={<Configuratore />} />
            <Route path="/traccia-ordine" element={<TracciaOrdine />} />
            <Route path="/admin-ordini" element={<AdminOrdini />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/meraviglia-del-vetro" element={<MeravigliaDelVetro />} />
          <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
          </Routes>
          <CookieBanner />
          <WhatsAppFloat />
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
